<!--学习培训-->
<template>
  <div class="trainingPage">

    <div style="display: flex">
      <!--    <div class="training">-->
      <!--      <el-row :gutter="0">-->
      <!--        <el-col class="training-col" :span="18">-->
      <div class="train-info">
        <div class="train-title">{{ data.name }}</div>
        <video id="train-video" controls="" :src="videoUrl"></video>

        <div class="remark">
          <div class="content">{{ data.remark }}</div>

          <div class="content-tag">
            <span>{{ data.studyCount }}人已学习</span>
            <span>观看结束获得{{ data.classHour }}学时</span>
          </div>

          <div class="title">选集</div>

          <div class="list-content">
            <a v-for="(item, index) in data.videos" :class="id === item.id ? 'active' : ''"
               @click="clickInfo(item.id)">
              {{ index < 9 ? '0' + (index + 1) : index + 1 }}
            </a>
          </div>
        </div>
      </div>

      <div class="rightContainer">
        <ul class="right-download">
          <li>
            <div class="right-download-div  right-download-app">
             
            </div>
          </li>
          <li>
            <div class="right-download-div right-download-xcx">
             
            </div>
          </li>
          <li>
            <div class="right-download-div right-download-wechat">
              
            </div>
          </li>
        </ul>
      </div>
      <!--        </el-col>-->

      <!--        <el-col :span="6">-->
      <!--          <div class="training-col">-->
      <!--            <div style="font-size: 18px; font-weight: bold;padding-bottom: 10px">精选课程</div>-->
      <!--            <div class="training-div">-->
      <!--              <div class="training-content" v-for="(item, index) in list" :key="index"-->
      <!--                   @click="onSampleCourses(item.id)">-->
      <!--                <img class="training-content-img"-->
      <!--                     :src="item.imgUrl"/>-->
      <!--                <div class="training-content-info">-->
      <!--                  <div class="card-title">{{ item.name }}</div>-->
      <!--                  <div style="color: #999999FF; padding: 5px 0;font-size: 14px"><i class="el-icon-time"></i> 总时长 {{-->
      <!--                      item.totalDuration-->
      <!--                    }}-->
      <!--                  </div>-->
      <!--                  <div style="color: #999999FF;font-size: 14px"><i class="el-icon-user"></i> {{ item.studyCount }}人已学习-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </el-col>-->
      <!--      </el-row>-->

    </div>

    <template v-if="list.length>0">
      <div style="font-size: 16px; font-weight: bold;padding-bottom: 8px;padding-top: 16px">精选课程</div>

      <div style=" ">
        <div class="swiper-father">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in list" :key="index" :data-id="item.id"
                   :data-type="item.typeId">
                <div class="swiper-content">
                  <img class="swiper-content-img" style="width: 100%;height: 110px;max-width: 200px"
                       :src="item.imgUrl"/>

                  <div class="swiper-content-info">
                    <div class="train-name">{{ item.name }}</div>

                    <div style="font-size: 12px">
                      <div style="color: #999999FF;">
                        <i class="el-icon-time"></i> 总时长 {{
                          item.totalDuration
                        }}
                      </div>
                      <div style="color: #999999FF">
                        <i class="el-icon-user"></i>
                        {{ item.studyCount }}人已学习
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <!--        <div class="swiper-pagination"></div>-->


            <!-- 如果需要滚动条 -->
            <!--    <div class="swiper-scrollbar"></div>-->
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>

        </div>
      </div>
    </template>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>本视频已学完,是否继续学习</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateVideo">继续学习</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {courseDetail, videoEnd, trainArea, excellent} from '@api/train'
import Swiper from 'swiper'
import {getWxqr} from "@api/home";

export default {
  name: 'trainingInfo',
  components: {},
  data() {
    return {
      appQrCode: 'http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/QRCode/app.png',
      xcxQrCode: 'http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/QRCode/xiaochengxu.jpg',
      qunQrCode: '',
      dialogVisible: false,
      id: undefined,
      courseId: undefined,
      data: {},
      videoUrl: undefined,
      total: 0,
      pageNum: 1,
      pageSize: 15,
      tabs: [],
      list: []
    }
  },
  created() {
    if (localStorage.getItem('ygw-city')) {
      this.cityJson = JSON.parse(localStorage.getItem('ygw-city'))
    }
    let timestamp = Date.parse(new Date())
    this.appQrCode = this.appQrCode + '?time=' + timestamp
    this.xcxQrCode = this.xcxQrCode + '?time=' + timestamp
    this.courseId = this.$route.query.courseId
    this.id = this.$route.query.courseId
    this.contentDetail()

    this.getTrainArea()

    this.getWxqr()
  },
  mounted() {
    // 延迟1秒
    setTimeout(() => {
      // 监听视频是否播放完毕
      if (!this.state) {
        document.querySelector('video').loop = false // 不设置视频循环播放;
        document.querySelector('video').addEventListener('ended', () => { //该视频播放是否已结束
          this.state = true
          this.videoEnd()
        }, false)
      }
    }, 2000)

    setTimeout(() => {
      this.initSwiper()
    }, 500)
  },
  methods: {

    // 根据地区获取微信二维码
    getWxqr() {
      getWxqr({
        cityCode: this.cityJson.cityId
      }).then(res => {
        if (res.data.code === 200) {
          this.qunQrCode = res.data.data.qrUrl
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    // 获取详情
    contentDetail() {
      courseDetail({
        id: this.courseId
      }).then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
          this.videos = res.data.data.videos
          this.id = res.data.data.videos[0].id
          this.updateVideo()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    // 查看详情
    clickInfo(id) {
      if (id == this.id) {
        return
      }
      this.id = id
      this.updateVideo()
    },

    // 课程点击
    onSampleCourses(id, typeId) {
      if (id == this.courseId) {
        return
      }
      // this.enterRouter('trainingInfo', {courseId: id})
      this.courseId = id
      this.tabPosition = typeId
      this.contentDetail()
      this.getTrainList()
      // 滚动到顶部
      window.scrollTo({
        'top': 0,
        'behavior': 'smooth'
      })
    },

    updateVideo() {
      this.dialogVisible = false
      for (let i = 0; i < this.videos.length; i++) {
        if (this.id == this.videos[i].id) {
          this.videoUrl = this.videos[i].videoUrl
          this.$forceUpdate()
        }
      }
    },

    // 视频播放完调用
    videoEnd() {
      videoEnd({id: this.id, courseId: this.courseId}).then(res => {
        if (res.data.code === 200) {
          this.content = res.data.data
          if (this.content.nextVideo) {
            this.id = this.content.nextVideo.id
            this.updateVideo()
            this.dialogVisible = false
          } else {
            let message = '本课程已学完！'
            if (this.content.info) {
              message = this.content.info
            }
            this.$message.success(message)
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    // tab切换
    tabChange(e) {
      this.pageNum = 1
      this.tabPosition = e
      this.getTrainList()
    },

    // 获取功能区数据
    getTrainArea() {
      trainArea().then(res => {
        if (res.data.code === 200) {
          this.tabs = res.data.data
          if (this.tabs.length > 0) {
            this.tabPosition = res.data.data[0].typeId
            this.getTrainList()
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    // 获取列表数据
    getTrainList() {
      var params = {
        typeId: this.tabPosition
      }
      this.loadingGoods = true
      excellent(params).then(res => {
        if (res.data.code === 200) {
          this.loadingGoods = false
          if (res.data.data && res.data.data.length > 0) {
            this.ifHasProduct = true
            this.list = res.data.data
          } else {
            this.ifHasProduct = false
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    // 初始化swiper
    initSwiper() {
      var that = this
      // var swiper = new Swiper('.swiper', {
      //   loop: 1 === 1,
      //   // 如果需要分页器
      //   pagination: '.swiper-pagination',
      //   autoplay: 1 === 1 ? 3000 : false,
      // })
      //
      // // swiper点击事件
      // swiper.on('click', function (swiper) {
      //   let jumpType = swiper.clickedSlide.attributes['data-type'].nodeValue
      //   let jumpUrl = swiper.clickedSlide.attributes['data-url'].nodeValue
      //
      //   // 判断跳转类型为原生且地址为登录，弹出登录窗
      //   if (jumpType == 1 && jumpUrl === "login") {
      //     that.showDownload()
      //   }
      // })

      var swiper = new Swiper('.swiper-container', {
        grid: {
          fill: 'column',
          rows: 1,
        },
        loop: true,
        slidesPerView: '4',
        spaceBetween: 8,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
      })

      // swiper点击事件
      swiper.on('click', function (swiper) {
        let type = swiper.clickedSlide.attributes['data-type'].nodeValue
        let id = swiper.clickedSlide.attributes['data-id'].nodeValue

        that.onSampleCourses(id, type)
      })
    },
  }
}
</script>

<style scoped lang="scss">

.rightContainer {
  width: 368px;
  margin-left: 8px;

  li {
    border-radius: 8px;
    box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.0500);
    margin-bottom: 8px;

    img {
      width: 110px;
      height: 110px;
      margin: 12px 25px;
    }
  }

  .right-download-div {
    height: 140px;
    width: 365px;
    background-size: contain !important;
    cursor: pointer;
    left: -1px;
    color: #fff;
    font: 12px arial, simsun, sans-serif;
    padding-top: 3px;
  }

  .right-download-app {
    background: url(http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/getJob/right_download_app_lgsc@2x.png) no-repeat;
  }

  .right-download-xcx {
    background: url(http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/getJob/right_download_xiaochengxu_lgsc@2x.png) no-repeat;
  }

  .right-download-wechat {
    background: url(http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/getJob/right_download_wechat_lgsc@2x.png) no-repeat;
  }

  .headTitle {
    width: 100%;
    background: #EDF5FE;
    border-radius: 6px 6px 0px 0px;
    padding: 8px 11px;
    font-weight: bold;
    color: #333333;
    font-size: 16px;
  }

  .recommend:hover {
    color: #096CEF;
  }

  .recommend {
    width: 100%;
    background: #fff;
    padding: 16px 10px 0;

    .recommend-title {
      width: 230px;
    }

    .recommend-time {
      text-align: right;
      width: 115px;
    }

    &:last-child {
      padding-bottom: 16px;
    }

    a {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      font-size: 14px;
    }
  }
}

.swiper {
  text-align: center;
  position: relative;
  height: auto;
  width: 100%;
  overflow: hidden;

  .swiper-wrapper {
    .swiper-slide {
      width: 100% !important;
      height: 100%;
    }

    .banner-img {
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}

.swiper-container {
  height: auto;
  width: 100%;

  .swiper-content:hover {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.28);

    .swiper-content-info {
      color: #37a0ff;
    }
  }

  .swiper-content {
    background: #fff;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);

    .swiper-content-img {
      width: 100%;
      height: 195px;
      border-radius: 5px 5px 0 0;
    }

    .swiper-content-info {
      background: #fff;
      padding: 8px;
      border-radius: 5px;
    }
  }

  .swiper-wrapper {
    .swiper-slide {
      width: 100%;
      height: 100%;
    }
  }
}

.swiper-father {
  width: 870px;
  margin-left: 0;
  z-index: 0;
  position: relative;
}

/*轮播按钮属性*/
.swiper-container {
  width: 90%;
  height: 100%;
  z-index: 9999;
}

/*自定义 swiper 左右按钮样式*/
.swiper-button-prev {
  background-size: 50px;
  background-image: url('http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/home/home_peixun_arrow_left@2x.png');
}

.swiper-button-next {
  background-size: 50px;
  background-image: url('http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/home/home_peixun_arrow_right@2x.png');
}

.train-name {
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}

.train-info {
  padding-bottom: 16px;
  width: 871px;
  //min-height: 790px;
  background: #FFFFFF;
  box-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.05);
  border-radius: 6px;


  .train-title {
    padding: 15px;
    font-size: 20px;
    font-weight: bold;
  }

  #train-video {
    height: 475px;
    width: 100%;
    padding: 15px;
  }

  .remark {
    padding: 10px 28px;

    .title {
      font-size: 18px;
      font-weight: bold;
      padding: 30px 0 15px 0;
    }

    .content {
      padding-bottom: 16px;
      line-height: 24px;
    }

    .content-tag {
      span {
        font-size: 12px;
        color: #999999FF;
        background-color: #EEEEEEFF;
        padding: 6px 20px;
        margin-right: 20px;
        border-radius: 25px;
      }
    }
  }

  .list-content {
    margin-top: 6px;

    a {
      background-color: #EEEEEEFF;
      padding: 7px 35px;
      margin-right: 20px;
      border-radius: 25px;
    }

    .active {
      color: #FFFFFFFF;
      background-color: #37A1FFFF;
    }
  }
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

//noinspection CssInvalidPseudoSelector
::v-deep .el-pager li {
  background: #f9f9f9 !important;
}

//noinspection CssInvalidPseudoSelector
::v-deep .el-pager li.active {
  background-color: #096CEFFF !important;
  color: #FFFFFF;
}

//noinspection CssInvalidPseudoSelector
::v-deep .el-pagination .btn-next {
  background: center center no-repeat #f9f9f9;
}

//noinspection CssInvalidPseudoSelector
::v-deep .el-pagination .btn-prev {
  background: center center no-repeat #f9f9f9;
}

.training-tab {
  margin: 0 10px;
  border-radius: 5px;
}

//noinspection CssInvalidPseudoSelector
::v-deep .el-radio-button__inner {
  border: 0 !important;
  background: bottom !important;
  font-size: 16px !important;
}

//noinspection CssInvalidPseudoSelector
::v-deep .is-active .el-radio-button__inner {
  border-radius: 5px !important;
  background: #096CEFFF !important;
}

.training-col {
  margin-bottom: 20px;
}

.training-div {
  max-height: 850px;
  overflow-y: auto;

  .training-content:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.28);

    .card-title {
      color: #37a0ff;
    }
  }

  .training-content {
    margin-bottom: 15px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);

    .training-content-img {
      width: 100%;
      height: 170px;
      border-radius: 5px 5px 0 0;
    }

    .training-content-info {
      background: #fff;
      padding: 10px 15px 15px 15px;
      border-radius: 5px;
    }
  }
}


.trainingPage {
  width: 100%;
  margin-bottom: 60px;
  margin-top: 16px;
}

.training {
  margin-top: 20px;
  width: 870px;
}
</style>
